import { gql } from '@apollo/client';

export const FETCH_BCP_DEVELOPED = gql`
  query GetBCPDeveloped($filter: DivisionFilterInput!) {
    bcpDeveloped(filter: $filter) {
      averageWeeks
      totalDeveloped
    }
  }
`;

export const FETCH_LOCATION_BCP_DEVELOPED = gql`
  query GetBCPDeveloped($filter: LocationFilterInput!) {
    bcpProcessAreaDeveloped(filter: $filter) {
      averageWeeks
      totalDeveloped
    }
  }
`;

export const FETCH_COMPANY_REVENUE = gql`
  query GetCompanyRevenue($filter: DependencyDivisionFilterInput!) {
    companyRevenueMapped(filter: $filter) {
      totalPercentage
      totalRevenue
    }
  }
`;

export const FETCH_LOCATION_COMPANY_REVENUE = gql`
  query GetCompanyRevenue($filter: LocationFilterInput!) {
    companyRevenueMappedByLocation(filter: $filter) {
      totalPercentage
      totalRevenue
    }
  }
`;

export const FETCH_CORPORATE_BCP_LOCATIONS = gql`
  query GetBcpLocation($filter: DivisionFilterInput!) {
    bcpLocationStatus(filter: $filter) {
      totalFinalized
      totalInProgress
      totalLocations
      totalNotStarted
      totalOutdated
    }
  }
`;

export const FETCH_LOCATION_BCP_PA = gql`
  query GetBcpLocationRH($filter: LocationFilterInput!) {
    bcpProcessAreaStatus(filter: $filter) {
      totalFinalized
      totalInProgress
      totalProcessAreas
      totalNotStarted
      totalOutdated
    }
  }
`;

export const FETCH_RISK_HUB_MATRIX = gql`
  query GetRiskHubMatrix($filter: DependencyDivisionFilterInput!) {
    divisionView(filter: $filter) {
      divisions {
        name
        percentage
        uuid
      }
      location {
        locationType
        locationName
        uuid
      }
      totalPercentage
      totalRevenue
    }
  }
`;
export const FETCH_LOCATION_RISK_HUB_MATRIX = gql`
  query GetLocationBCPMatrix($filter: LocationFilterInput!) {
    processAreaMatrix(filter: $filter) {
      divisions {
        name
        percentage
        supportedRevenue
        uuid
      }
      processArea
      totalPercentage
      totalRevenue
    }
  }
`;

export const FETCH_CHART = gql`
  query GetChart($filter: DivisionFilterInput!) {
    exposureByLocation(filter: $filter) {
      bcpStatus
      location {
        locationName
        uuid
      }
      mitigatedRevenue
      unmitigatedRevenue
    }
  }
`;

export const FETCH_LOCATION_CHART = gql`
  query GetLocationExposureGraph($filter: LocationFilterInput!) {
    exposureByProcessArea(filter: $filter) {
      bcpStatus
      mitigatedRevenue
      processArea
      unmitigatedRevenue
    }
  }
`;

export const FETCH_BLACKSWAN = gql`
  query GetBlackswan($filter: DivisionFilterInput!) {
    blackSwan(filter: $filter) {
      score
    }
  }
`;

export const FETCH_LOCATION_BLACKSWAN = gql`
  query GetBlackswan($filter: LocationFilterInput!) {
    blackSwanByLocation(filter: $filter) {
      score
    }
  }
`;

export const FETCH_LOCATION_EXPOSURE = gql`
  query GetExposureForRebuildTime($filter: LocationFilterInput!) {
    exposureForRebuildTime(filter: $filter) {
      mitigation
      rebuildTime
      residualExposure
      totalExposure
    }
  }
`;

export const FETCH_LOCATION_DIVISIONS = gql`
  query GetSupportedDivisions($filter: LocationFilterInput!) {
    divisionsSupported(filter: $filter) {
      division
      totalPercentage
      totalSupported
    }
  }
`;

export const FETCH_LOCATION_SUPPLIERS_MAPPED = gql`
  query GetSuppliersMapped($filter: LocationFilterInput!) {
    suppliersMappedByLocation(filter: $filter) {
      addedSuppliers
      totalSuppliers
    }
  }
`;

export const FETCH_LOCATION_TOP_SUPPLIER_DEPENDENCIES = gql`
  query GetTopSuppliersDependencies($filter: LocationFilterInput!) {
    topSuppliersDependencies(filter: $filter) {
      associatedRevenue
      percentage
      supplierName
    }
  }
`;
